module.exports = __webpack_public_path__ + "media/images/application/icons/icon-back-e9094ac5d669c993886763202801dc96.svg";